import {Injectable, Injector} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {ApplicationInsightsService} from './application-insights.service';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {IExceptionTelemetry} from '@microsoft/applicationinsights-web';

export const InterceptSkipErrorHeader = 'X-Skip-Error-Interceptor';
@Injectable({
  providedIn: 'root',
})
/**
 * Handles globalhttperrorinterceptorservice for this module.
 */
export class GlobalHttpErrorInterceptorService implements HttpInterceptor {
  constructor(private injector: Injector) {
  }

  /**
   * Handles intercept for this module.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(InterceptSkipErrorHeader)) {
      const headers = req.headers.delete(InterceptSkipErrorHeader);
      return next.handle(req.clone({headers}));
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // POST this error information to Azure App Insights
        const loggedError = new Error(error.message);
        loggedError.name = error.name;

        const appInsightException: IExceptionTelemetry = {
          exception: loggedError,
          properties: error.error,
        };

        const appInsightService = this.injector.get(ApplicationInsightsService);
        if (appInsightService.appInsights != null) {
          appInsightService.appInsights.trackException(appInsightException);
        }
        return throwError(error);
      }),
    );
  }

}


